import React from 'react';
import { FootNoteProps } from '../models/TopLevelTemplateComponentProps';
import { Palette } from 'Palette';
import { FootNoteContainer, FootNoteItem } from './styles/FootNote';

interface FootnoteRendererProps {
  footnotes?: FootNoteProps[];
  tone?: keyof typeof Palette;
  className?: string;
  noTopMargin?: boolean;
}

const FootnoteRenderer: React.FC<FootnoteRendererProps> = ({ footnotes, tone = 'default' }) => {
  if (!footnotes || footnotes.length === 0) {
    return null;
  }

  // Sort footnotes by number to ensure proper order
  const sortedFootnotes = [...footnotes].sort((a, b) => a.number - b.number);

  return (
    <FootNoteContainer tone={tone}>
      {sortedFootnotes.map((footnote) => (
        <FootNoteItem
          key={footnote.id}
          id={`footnote-${footnote.number}`}
          number={footnote.number}
          content={footnote.content}
          tone={tone}
        />
      ))}
    </FootNoteContainer>
  );
};

export default FootnoteRenderer;
